<template>
  <div class="pe-site-plan-design-grade-exam-style">
    <div class="body"
         v-loading="committing"
         element-loading-text="提交中，请稍等...">
      <el-form size="mini"
               label-width="72px">
        <el-form-item label="考核方式">
          <el-select v-model="form.flagExamStyle"
                     size="mini"
                     placeholder="请选择考核方式"
                     loading-text="加载中..."
                     :loading="loading"
                     @visible-change="loadFlagExamStyles">
            <template v-if="flagExamStyles">
              <el-option v-for="flagExamStyle in flagExamStyles"
                         :key="flagExamStyle.id"
                         :label="flagExamStyle.name"
                         :value="flagExamStyle.code"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">提交保存</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeSitePlanDesignGradeExamStyle',
  props: {
    preHandleParams: {
      type: Function,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      flagExamStyles: null,
      form: {
        flagExamStyle: ''
      },
      committing: false
    }
  },
  methods: {
    loadFlagExamStyles (popperVisible) {
      if (popperVisible && !this.loading && !this.flagExamStyles) {
        this.loading = true
        this.$ajax({
          url: '/workspace/manager/portal/data/select/flagExamStyles',
          method: 'post'
        }).then(response => {
          if (response.data) {
            this.flagExamStyles = response.data['flagExamStyles'] || []
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleApply () {
      if (!this.form.flagExamStyle) {
        this.$message.warning('请选择考核方式')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/basic/peSite/plan/course/examStyle',
        method: 'post',
        data: this.$qs.stringify(this.$extend(this.preHandleParams(), this.form, this.extraParams), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        switch (response.data['responseCode']) {
          case 'SUCCESS': {
            this.$message.success(response.data['message'])
            this.$nextTick(() => {
              this.$emit('hidePopoverAndRefresh')
            })
            break
          }
          default: {
            this.$message.warning(response.data['message'])
            break
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .pe-site-plan-design-grade-exam-style {
    & > .body {
      padding: 20px 30px 20px 15px;
      .el-form {
        .el-form-item {
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
